$(function () {

    var url = location.protocol + "//" + location.host + "/myoda/";
    var urlFR = location.protocol + "//" + location.host + "/fr/myoda/";
    var countValues = 0;
    if(window.location.href.indexOf(url) != -1 || window.location.href.indexOf(urlFR) != -1){
        if (localStorage.getItem("filterData")) {
            var data = localStorage.getItem("filterData");
            data = JSON.parse(data);
            if (data.length > 5) {
                console.log(data);
                var fillJobs = [];
                jQuery.each(data, function(index, val) {
                    if (val.name == 'jobs[]') {
                        fillJobs.push(val.value);
                    } else {
                        $("[name='"+val.name+"']").val(val.value);
                    }
                    if (val.value != '') {
                        countValues++;
                    }
                });
                $("[name='jobs[]']").val(fillJobs);
                setTimeout(function(){$("#filter_angebote").click()}, 100);
            }
        }
    }

    if (window.location.href.indexOf("myoda/detail") == -1) {
        localStorage.removeItem("filterData");
    }

    var restCalls = $('[data-rest]');
    var nonce = $('body').data('rest-nonce');

    restCalls.each(function(i, caller) {
        var parent = $(caller);
        var api = parent.data('rest');
        var apiUrl = api.endpoint;
        var apiFilter = '';

        if (api && api.endpoint.length) {
            var tmpl = parent.find('.tmpl-item');
            var itemsContainer = parent.find('[data-items]');
            var error = parent.find('[data-error]');
            var notFound = parent.find('[data-notfound]');
            var btnLoadMore = parent.find('[data-loadmore]');
            var btnFilter = parent.find('[data-filter-send]');
            var spinner = parent.find('[data-spinner]');
            var loadmoreSpinner = parent.find('[data-loadmore-spinner]');
            var resetOffersFilter = parent.find('[data-filter-reset-offers]');
            // var globalSearch = parent.find('[data-filter-global-search]');


            apiCall(true);

            btnLoadMore.on('click', function (event) {
                event.preventDefault();

                var offset = $('.offset-posts').val();
                var parseOffset = parseInt(offset);
                parseOffset = parseOffset + 6;
                $('.offset-posts').val(parseOffset);
                apiFilter = $.param($('.offset-posts').serializeArray());
                if (window.filterSet == true) {
                    var dataArr = $('[data-filter]').serializeArray();
                    apiFilter = $.param(dataArr);
                }
                api.currentpage++;
                apiCall(false, true);
            });

            btnFilter.on('click', function (event) {
                event.preventDefault();
                api.currentpage = 1;
                $('.offset-posts').val(0);
                var dataArr = $('[data-filter]').serializeArray();
                apiFilter = $.param(dataArr);
                apiCall(true);
                loadmoreStop();
                window.filterSet = true;
                localStorage.setItem('filterData', JSON.stringify(dataArr));
            });

            resetOffersFilter.on('click', function (event) {
                event.preventDefault();
                localStorage.removeItem("filterData");
                var parent = $(this).closest('[data-rest]');
                parent.find('[data-show-filter-area].showing').removeClass('showing');
                parent.find('[data-filter-target].show').removeClass('show');
                parent.find('.rest-filter :input')
                    .not(':button, :submit, :reset, :hidden')
                    .val('')
                    .prop('checked', false)
                    .prop('selected', false)
                    .trigger('change');
                $('.offset-posts').val(0);
                apiFilter = $.param($('.offset-posts').serializeArray());
                api.currentpage = 1;
                window.filterSet = false;
                apiCall(true);
            });
        }

        function apiCall(reset, loadmoreClick) {
            // ie11 fix > does not support default params
            if (!loadmoreClick) {loadmoreClick = false;}
            var restUrl = prepareUrl();
            var loadMoreLimit = 6;
            if ($("#social-wall").length) {
                loadMoreLimit = 3;
            }
            $('.no-more-offers').hide();


            $.ajax({
                    type: 'GET',
                    url: restUrl,
                    data: apiFilter,
                    beforeSend: function (xhr) {
                        if (nonce && nonce.length) {
                            xhr.setRequestHeader('X-WP-Nonce', nonce);
                        }

                        if (reset) {
                            loadingStart();
                        } else {
                            loadmoreStart();
                        }
                    }
                })
                .done(function (result) {
                    console.log("RE2S");
                    console.log(result);

                    $(".total .value").text(result.total);

                    if (reset) {
                        deleteItems();
                    }
                    var isArray = Array.isArray(result.data);
                    error.addClass('d-none');
                    notFound.addClass('d-none');
                    if (result.data && result.data == null) {
                        // loadingStop();
                        if (loadmoreClick == true) {
                            $('.no-more-offers').show();
                        } else {
                            notFound.removeClass('d-none');
                        }
                        btnLoadMore.addClass('d-none');
                    }

                    // if (result.data && (result.total <= loadMoreLimit || parseInt(result.offset) + result.data.length >= result.total)) {
                    //     btnLoadMore.addClass('d-none');
                    // } else {
                    //     btnLoadMore.removeClass('d-none');
                    // }
                    if (isArray) {
                        updateItems(result);
                        api = result;
                        if (result.data && result.data.length <= 0) {
                            notFound.removeClass('d-none');
                        }
                        if (result.data && (result.total <= loadMoreLimit || parseInt(result.offset) + result.data.length >= result.total)) {
                            btnLoadMore.addClass('d-none');
                        } else {
                            btnLoadMore.removeClass('d-none');
                        }
                    } else {
                        if (result.offset == "0") {
                            notFound.removeClass('d-none');
                            finish();
                        }

                        btnLoadMore.addClass('d-none');
                        return;
                    }

                    if (api.currentpage >= api.totalpages) {
                        finish();
                    } else {
                        btnLoadMore.show();
                    }
                })
                .fail(function (result) {
                    error.removeClass('d-none');
                    console.warn(result);
                })
                .always(function () {
                    if (reset) {
                        loadingStop();
                    } else {
                        loadmoreStop();
                    }
                });
        }

        function prepareUrl() {
            var url = apiUrl;
            Object.keys(api).forEach(function (k) {
                url = url.replace("#"+k+"#", api[k]);
            });
            return url;
        }

        function finish() {
            btnLoadMore.hide();
        }

        function loadingStart() {
            spinner.show();
            parent.addClass('loading');
        }

        function loadingStop() {
            spinner.hide();
            parent.removeClass('loading');
        }

        function loadmoreStart() {
            loadmoreSpinner.show();
            parent.addClass('loadmore');
        }

        function loadmoreStop() {
            loadmoreSpinner.hide();
            parent.removeClass('loadmore');
        }

        function deleteItems() {
            itemsContainer.empty();
        }

        function updateItems(result) {
            var items = result.data;
            for (let i = 0; i < items.length; i++) {
                var item = items[i];

                var source = tmpl[0].innerHTML;
                var template = Handlebars.compile(source);
                var html = template(item);
                if (parent.attr('data-rest-masonry')) {
                    var $elems = $(html);
                    $('.grid').append($elems).masonry('appended', $elems);
                } else {
                    itemsContainer.append(html);
                }
                showItem(item.id);
            }

        }

        function showItem(id) {
            setTimeout(function () {
                $('[data-item="' + id + '"]').addClass('shownow');
                $(window).trigger('restUpdatedItems');
            }, 100);
        }
    });
});
